import { isPlatformBrowser } from '@angular/common';
import { AfterViewInit, Component, Inject, Input, PLATFORM_ID } from '@angular/core';
import { RouterModule } from '@angular/router';
import { UtilsService } from 'src/app/_services/utils.service';
import { SharedModule } from 'src/app/_shared/_shared.module';
import { BtnLinkComponent } from 'src/app/_shared/bloque-buttons/btn-link/btn-link.component';
import { SectionVentaja, Ventaja } from 'src/app/_shared/bloque-secciones-reutilizables/_models/ventaja';

import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';

@Component({
  selector: 'app-ventajas',
  standalone: true,
  imports: [SharedModule, RouterModule, BtnLinkComponent],
  templateUrl: './ventajas.component.html',
  styleUrls: ['./ventajas.component.scss']
})
export class VentajasComponent implements AfterViewInit
{
  @Input() ventajasData: Ventaja[];
  @Input() sectionVentajaData: SectionVentaja;
  @Input() isCFFactoring: boolean;
  @Input() returnUrl: string;
  swiperVentajas: Swiper;
  contenedorMargen: number;

  constructor(
    @Inject(PLATFORM_ID) private _platformId: Object,
    private _utilsService: UtilsService
  ) { }

  ngAfterViewInit(): void
  {
    this.getContainerMargins();
    // TODO: revisar si se puede quitar el setTimeout sustituindole por un cambio de detección de cambios
    setTimeout(() => this.buildSwiper(), 0);
  }

  private getContainerMargins(): void
  {
    this.contenedorMargen = this._utilsService.getContainerMargins('contenedor-titulo-ventaja');
  }

  private buildSwiper(): void
  {
    const swiperClass = this.sectionVentajaData.refSwiper
    const swiperPaginationClass = `.${swiperClass}-pagination`;
    this.swiperVentajas = new Swiper(`.${swiperClass}`, {
      modules: [Pagination],
      slidesPerView: 1.2,
      spaceBetween: 10,
      slidesOffsetAfter: this.contenedorMargen,
      slidesOffsetBefore: this.contenedorMargen,
      breakpoints: {
        360: {
          slidesPerView: 1.2,
          spaceBetween: 25
        },
        576: {
          slidesPerView: 1.5,
          spaceBetween: 25
        },
        768: {
          slidesPerView: 2.3,
          spaceBetween: 30
        },
        992: {
          slidesPerView: this.ventajasData.length > 3 ? 3.5 : 3,
          spaceBetween: 30,
          slidesOffsetAfter: this.ventajasData.length === 3 ? 0 : this.contenedorMargen,
          slidesOffsetBefore: this.ventajasData.length === 3 ? 0 : this.contenedorMargen,
        },
        1400: {
          spaceBetween: 30,
          slidesPerView: this.ventajasData.length > 3 ? 4 : 3,
          slidesOffsetAfter: 0,
          slidesOffsetBefore: 0,
        }
      },
      pagination: {
        el: swiperPaginationClass,
        clickable: true
      },
      on: {
        init: () =>
        {
          const contenedorSwiper = document.getElementById('swiper-container-ventajas');
          if ((window.innerWidth > 991.98 && this.ventajasData.length === 3) || window.innerWidth > 1399.98)
          {
            contenedorSwiper.style.marginLeft = this.contenedorMargen + 'px';
            contenedorSwiper.style.marginRight = this.contenedorMargen + 'px';
          }
        }
      }
    });
  }
}
